module.exports = "/src/views/player/hudevo/phonenew/assets/images/gallery.png";